import React from "react";
import { useMsal } from "@azure/msal-react";
import Modal from "./Modal";
import Button from "./Button";
import { getLoginRequest } from "../../config/authConfig";
import { redirectToLoginWithError } from "../../utils/authRedirect";
import { SESSIE_VERLOPEN } from "../../utils/authMessages";

// Toont een modal wanneer een API-call een definitieve 401 geeft, i.p.v. hard
// te redirecten. Blijft op de huidige pagina zodat state behouden blijft.
export default function SessionExpiredModal() {
  const { instance } = useMsal();
  const [open, setOpen] = React.useState(false);
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    // Signaleer aan apiClient dat de handler actief is.
    window.__sessionExpiredHandlerMounted = true;
    const onExpired = () => setOpen(true);
    window.addEventListener("app:session-expired", onExpired);
    return () => {
      window.__sessionExpiredHandlerMounted = false;
      window.removeEventListener("app:session-expired", onExpired);
    };
  }, []);

  const handleReauth = async () => {
    setBusy(true);
    try {
      await instance.acquireTokenPopup(getLoginRequest());
      setOpen(false); // succes: modal sluiten, paginastate blijft
    } catch {
      // Popup geblokkeerd/gesloten: val terug op redirect-flow.
      redirectToLoginWithError(SESSIE_VERLOPEN);
    } finally {
      setBusy(false);
    }
  };

  const handleCancel = () => setOpen(false);

  return (
    <Modal
      open={open}
      title="Sessie verlopen"
      onClose={handleCancel}
      footer={
        <>
          <Button variant="secondary" onClick={handleCancel} disabled={busy}>
            Annuleren
          </Button>
          <Button onClick={handleReauth} disabled={busy}>
            {busy ? "Bezig…" : "Opnieuw aanmelden"}
          </Button>
        </>
      }
    >
      <p style={{ margin: 0, color: "#334155", fontSize: "14px" }}>{SESSIE_VERLOPEN}</p>
    </Modal>
  );
}
